import { ReactElement } from 'react';

import { useCashierConfiguration } from '@cashier/cashier-common';
import {
  InputTypes,
  IntegrationThemes,
  PaymentMethodInput,
} from '@cashier/cashier-model';

import { CopyableText } from './copyableText';
import { QrCode } from './qrCode';
import { Button } from './button';
import { UrlRow as DefaultUrlRow } from './urlRow/v1';
import { UrlRow } from './urlRow/v2';
import { TextRow as DefaultTextRow } from './textRow/v1';
import { TextRow } from './textRow/v2';
import { useUIConfiguration } from '@cashier/cashier-shared';

interface InformationBlockContentWrapperProps {
  field: PaymentMethodInput;
  theme: IntegrationThemes;
}

export const InformationBlockContentWrapper = ({
  field,
  theme,
}: InformationBlockContentWrapperProps): ReactElement => {
  const { direction } = useCashierConfiguration();
  const copyableTextType = useUIConfiguration('copyableText', 'type');
  const qrCodeType = useUIConfiguration('qrCode', 'type');

  switch (field.type) {
    case InputTypes.QrCode:
      return <QrCode type={qrCodeType} value={field.value?.toString() || ''} />;

    case InputTypes.Url:
      return (
        <>
          {IntegrationThemes.Default === theme && (
            <DefaultUrlRow
              label={field.label || ''}
              linkUrl={field.value as string}
            />
          )}
          {IntegrationThemes.Platform === theme && (
            <UrlRow
              label={field.label || ''}
              linkUrl={field.value as string}
              direction={direction}
            />
          )}
        </>
      );

    case InputTypes.Button:
      return (
        <Button
          label={field.label || ''}
          linkUrl={field.value?.toString() || ''}
        />
      );

    case InputTypes.CopyableText:
      return (
        <CopyableText
          name={field.name}
          text={field.value?.toString() || ''}
          label={field.label || ''}
          theme={theme}
          type={copyableTextType}
        />
      );

    default:
      return (
        <>
          {IntegrationThemes.Default === theme && (
            <DefaultTextRow
              label={field.label || ''}
              value={field.value?.toString() || ''}
            />
          )}
          {IntegrationThemes.Platform === theme && (
            <TextRow
              direction={direction}
              label={field.label || ''}
              value={field.value?.toString() || ''}
            />
          )}
        </>
      );
  }
};
